import { z } from 'zod';
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
import {} from "./persons.dto.js";
export const PersonSearchFiltersSchema = z.object({
    name: z.string().optional(),
    cpf: z.string().optional(),
});
const PaginatedQuerySchema = createPaginatedQuerySchema(PersonSearchFiltersSchema);
export const FindPersonsPaginatedRequestDTOSchema = z.object({
    params: z.object({
        companyId: z.string().uuid(),
    }),
    query: PaginatedQuerySchema,
});
//# sourceMappingURL=find-persons-paginated.dto.js.map